export default {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'Linkedin',
  twitter: 'Twitter',
  youtube: 'Youtube',
  'follow-instagram': 'Folge uns auf Instagram',
  'share-on': 'Teilen',
  flyers: 'Flugblätter und Flyer',
  'business-cards': 'Visitenkarten',
  'books-magazines': 'Zeitschriften, Bücher, Kataloge',
}
